import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Icon,
  Tooltip,
  ClickAwayListener,
  withStyles,
} from '@material-ui/core';
import { ToggleUI } from '../../../common';
import { Validate, Config } from '../../../../other';
import { useSelector } from 'react-redux';

const VentasList_ = ({ classes, modalHandler }) => {
  const { idCountry, ventas } = useSelector((state) => ({
    idCountry: state.tienda.Country_idCountry,
    ventas: state.ventas,
  }));

  const [observacion_venta_id, setObservacionState] = useState(0);
  const toggleObservacion = (v) => setObservacionState(v);

  if (ventas.length) {
    let body = ventas.map((venta, idx) => {
      let table_class =
        ventas.length - 1 === idx
          ? classes.table_cell_last
          : classes.table_cell;
      let envio_seleccionado = JSON.parse(venta.v_arr_envio_seleccionado_json);

      return (
        <TableRow hover key={idx}>
          <TableCell classes={{ root: table_class }}>
            <Link
              to={'/venta/' + venta.v_numero}
              className={classes.link_order}
            >
              <u>{venta.v_numero}</u>
            </Link>
          </TableCell>
          <TableCell classes={{ root: table_class }}>
            <div className={classes.customer_name}>
              {Validate.trim_ucwords(
                venta.v_facturacion_nombre + ' ' + venta.v_facturacion_apellido
              )}
              <ToggleUI show={venta.v_observacion ? true : false}>
                <ClickAwayListener onClickAway={() => toggleObservacion(0)}>
                  <Tooltip
                    PopperProps={{ disablePortal: true }}
                    onClose={() => toggleObservacion(0)}
                    open={observacion_venta_id === venta.v_numero}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={venta.v_observacion}
                    classes={{
                      tooltip: classes.tooltip,
                    }}
                  >
                    <IconButton
                      aria-label="Observacion"
                      onClick={(e) => toggleObservacion(venta.v_numero)}
                    >
                      <Icon style={{ fontSize: '1rem' }}>message</Icon>
                    </IconButton>
                  </Tooltip>
                </ClickAwayListener>
              </ToggleUI>
            </div>
          </TableCell>
          <TableCell classes={{ root: table_class }}>
            {Validate.label_estado_pago(venta.v_estado_pago)}
          </TableCell>
          <TableCell classes={{ root: table_class }}>
            {Validate.utc2local_format(venta.v_fecha, Config.SHORTDATE_FORMAT)}
          </TableCell>
          <TableCell classes={{ root: table_class }}>
            {Validate.label_metodo_pago(venta.v_metodo_pago)}
          </TableCell>
          <TableCell classes={{ root: table_class }}>
            {Validate.label_metodo_envio(
              venta.v_metodo_envio,
              envio_seleccionado
            )}
          </TableCell>
          <TableCell classes={{ root: table_class }}>
            {Validate.label_estado_envio(
              venta.v_metodo_envio,
              venta.v_estado_envio
            )}
          </TableCell>
          <TableCell classes={{ root: table_class }}>
            {Validate.label_costo_envio(
              venta.v_metodo_envio,
              venta.v_envio_costo,
              venta.v_envio_gratis,
              envio_seleccionado
            )}
          </TableCell>
          <TableCell classes={{ root: table_class }}>
            ${Validate.number_format(venta.v_monto, idCountry)}
          </TableCell>
          <TableCell classes={{ root: table_class }} align="center">
            <IconButton
              aria-label="Archivar"
              onClick={(e) => modalHandler(true, 'archivar_orden', venta)}
              disabled={venta.v_archivada ? true : false}
            >
              <Icon className="fas fa-archive" style={{ fontSize: '0.8rem' }} />
            </IconButton>
          </TableCell>
        </TableRow>
      );
    });

    return (
      <Card className={classes.card}>
        <CardContent className={classes.card_content_no_padding}>
          <Table className={classes.table} padding="dense">
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Cliente</TableCell>
                <TableCell>Pago</TableCell>
                <TableCell>Fecha</TableCell>
                <TableCell>Método de pago</TableCell>
                <TableCell>Método de envío</TableCell>
                <TableCell>Envío</TableCell>
                <TableCell>Costo del envío</TableCell>
                <TableCell>Monto (sin envío)</TableCell>
                <TableCell>Archivar</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{body}</TableBody>
          </Table>
        </CardContent>
      </Card>
    );
  } else {
    return (
      <Card className={classes.card}>
        <CardContent className={classes.card_content}>
          <Typography className={classes.list_item_title}>
            No se han encontrado ordenes
          </Typography>
        </CardContent>
      </Card>
    );
  }
};

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    minWidth: '100%',
  },
  card: {
    ...theme.card.card,
    padding: '0px !important',
  },
  card_content: theme.card.card_content,
  card_content_no_padding: {
    ...theme.card.card_content,
    padding: '0px !important',
    overflowX: 'auto',
  },
  card_actions: theme.card.card_actions_public,
  list_item_title: {
    fontSize: '1rem',
    margin: 0,
    padding: 0,
  },
  table_cell: {},
  table_cell_last: {
    borderBottom: '0px solid transparent',
  },
  link_order: {
    fontWeight: '700',
    color: 'inherit',
  },
  tooltip: {
    backgroundColor: '#000',
    whiteSpace: 'pre-line',
    lineHeight: '1.5',
    fontSize: '12px',
  },
  customer_name: {
    display: 'flex',
    alignItems: 'center',
  },
});

export const VentasList = withStyles(styles, { withTheme: true })(VentasList_);
